// Mode d'affichage : 'jour', 'nuit' ou 'auto' (le système décide). La bascule est un seul fondu tonal : une view
// transition quand le navigateur sait la faire, sinon une transition de couleurs le temps du changement.
import { state } from '../core/store.js';
import { CLES } from '../core/storage.js';

export function themeChoisi() { try { var t = localStorage.getItem(CLES.theme); return (t === 'jour' || t === 'nuit') ? t : 'auto'; } catch (e) { return 'auto'; } }
export function themeEffectif() {
    var c = themeChoisi();
    if (c !== 'auto') return c;
    try { return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'nuit' : 'jour'; } catch (e) { return 'jour'; }
}
export function appliquerTheme() {
    var c = themeChoisi();
    if (c === 'auto') document.documentElement.removeAttribute('data-theme');
    else document.documentElement.setAttribute('data-theme', c);
    var meta = document.querySelector('meta[name="theme-color"]:not([media])');
    if (meta) meta.setAttribute('content', themeEffectif() === 'nuit' ? '#1a1b1f' : '#f4f5f8');
}
// Le choix est mémorisé et enregistré tout de suite (synchrone : un départ de page dans la foulée l'emporte
// avec lui) ; seule la peinture passe par la transition.
function memoriser(t) {
    try { if (t === 'auto') localStorage.removeItem(CLES.theme); else localStorage.setItem(CLES.theme, t); } catch (e) {}
    state.themeSet = true;
    if (window.savePrefs) window.savePrefs();
}
function peindre() {
    appliquerTheme();
    if (window.renderHeader) window.renderHeader();
    if (window.renderFooter) window.renderFooter();
}
function mouvementReduit() { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
export function setTheme(t) {
    memoriser(t);
    if (document.startViewTransition && !mouvementReduit()) { document.startViewTransition(peindre); return; }
    var h = document.documentElement;
    h.classList.add('bascule-theme');
    peindre();
    setTimeout(function() { h.classList.remove('bascule-theme'); }, 280);
}
export function toggleTheme() { setTheme(themeEffectif() === 'nuit' ? 'jour' : 'nuit'); }
window.themeChoisi = themeChoisi; window.themeEffectif = themeEffectif; window.appliquerTheme = appliquerTheme;
window.actions.setTheme = setTheme; window.actions.toggleTheme = toggleTheme;
